import PasswordInput from "../../material/passwordInput/PasswordInput";

const PasswordRegistration = ({
    password,
    setPassword,
    disablePassword,
    confirmPassword,
    setConfirmPassword,
    disableConfirmPassword,
    regex
}) => {

  return (
    <>
      <div className="max-w-[1000px] mx-auto mt-8">
        <div className="text-[16px] leading-6 text-[#2E2E2E] font-medium mb-5">
          ตั้งค่าบัญชีผู้ใช้
        </div>

        <div className="grid grid-cols-2 md:grid-cols-1 gap-4">
          <PasswordInput
            regex={regex.password()}
            placeholder="รหัสผ่าน"
            label="รหัสผ่าน"
            value={password}
            setValue={setPassword}
            disabled={disablePassword}
          ></PasswordInput>

          <PasswordInput
            regex={regex.password()}
            placeholder="ยืนยันรหัสผ่าน"
            value={confirmPassword}
            setValue={setConfirmPassword}
            disabled={disableConfirmPassword}
          ></PasswordInput>
        </div>
      </div>
    </>
  );
};

export default PasswordRegistration;
